import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Promotion
      {record ? `: ${record.title}` : ''}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Promotion/Title.js